import React from 'react'
import { Switch, withRouter } from 'react-router-dom'
import {TransitionGroup, CSSTransition} from "react-transition-group";
import makeStyles from "@material-ui/core/styles/makeStyles";
import './styles.css'

const useStyles = makeStyles((theme) => ({
    group: {
        position: 'relative',
        height  : '100%',
        width   : '100%',
    },
    routes: {
        position: 'absolute',
        width   : '100%',
        height  : '100%',
        top     : 0,
        left    : 0,
    },
}));


const AnimatedSwitch = (props) => {
    const classes = useStyles();
    return (

            <TransitionGroup className={classes.group}>
                <CSSTransition
                    key={props.location.key}
                    classNames="fade"
                    timeout={{enter: 300, exit: 300}}
                >
                    <section className={classes.routes}>
                        <Switch location={props.location}>
                            {props.children}
                        </Switch>
                    </section>
                </CSSTransition>
            </TransitionGroup>
)};

export default withRouter(AnimatedSwitch);